import { render, staticRenderFns } from "./VuseLogoh.vue?vue&type=template&id=3062b63a&"
import script from "./VuseLogoh.vue?vue&type=script&lang=js&"
export * from "./VuseLogoh.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports